export default __webpack_public_path__ + "/350428__benjaminharveydesign__trumpet-fanfare.mp3";